module.exports = __webpack_public_path__ + "static/media/b-sci-major-3_LR.67bee0d4.jpg";